import { EdgeListRequiredWaiversRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListRequiredWaivers } from '@/modules/auth/use-cases'

export function makeListRequiredWaivers(): ListRequiredWaivers {
  return new EdgeListRequiredWaiversRepository(makeSupabaseEdgeHttpClient()).execute
}
